import { apiClient } from '@/api/core/apiClient';
import { API_CONFIG } from '@/api/core/apiConfig';
import type { ApiResponse } from '@/api/shared/types';
import type { LC_GetHolidayTypesListOut, HolidayType } from './holidayType.types';
import { mapHolidayTypeToModel } from './holidayType.mapper';


export class HolidayTypeCatalogService {
  async getHolidayTypes(signal?: AbortSignal): Promise<ApiResponse<HolidayType[]>> {
    const response = await apiClient.get<LC_GetHolidayTypesListOut>(
      API_CONFIG.ENDPOINTS.CATALOG.HOLIDAY_TYPES,
      { signal },
    );

    if (response.success && response.data) {
      return {
        ...response,
        data: response.data.map(mapHolidayTypeToModel),
      };
    }

    return { ...response, data: null };
  }
}

export const holidayTypeCatalogService = new HolidayTypeCatalogService();
